import { HTTP_METHODS } from '@studio/constants/axios';
import { CENTRAL_API_V3 } from '@studio/constants/env-variables';
import type { WebChannels } from '@studio/types';

export const root = {
  [HTTP_METHODS.GET]: {
    url: `${CENTRAL_API_V3}/customers/@customerId/webeventprofiles`,
    response: [] as WebChannels.Get.WebChannel[],
    method: HTTP_METHODS.GET,
  },
  [HTTP_METHODS.POST]: {
    url: `${CENTRAL_API_V3}/customers/@customerId/webeventprofiles`,
    request: {} as WebChannels.Post.WebChannel,
    method: HTTP_METHODS.POST,
  },
};

export const id = {
  [HTTP_METHODS.PATCH]: {
    url: `${CENTRAL_API_V3}/customers/@customerId/webeventprofiles/@id`,
    params: {} as { id: string },
    method: HTTP_METHODS.PATCH,
  },
  [HTTP_METHODS.DELETE]: {
    url: `${CENTRAL_API_V3}/customers/@customerId/webeventprofiles/@id`,
    params: {} as { id: string },
    method: HTTP_METHODS.DELETE,
  },
};
